module.exports = __webpack_public_path__ + "static/media/grid_01.fca3267a.png";